import React from 'react';

import { IMG_LOADING_ERROR_URL } from 'common/configuration/constants';
import { ACCOUNT_CONFIRMED_ERROR } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import trans from 'common/tools/translations/trans';
import { getResendConfirmationEmailUrl } from 'common/tools/userspace';

const AccountConfirmedErrorModal = () => {
  return (
    <ReactModal
      size="small"
      className="modal-welcome"
      title={trans('userspace.sign-up.server-error.title')}
    >
      <p className="vertical-spacing">
        {trans('userspace.account-activation-error')}
      </p>
      <img
        src={IMG_LOADING_ERROR_URL}
        className="centered-image content-img"
        width="240"
      />
      <a
        className="button button-inverse-full"
        href={getResendConfirmationEmailUrl(window.location.href)}
      >
        {trans('userspace.resend-activation-link')}
      </a>
    </ReactModal>
  );
};

export default buildReactDomModalModule(ACCOUNT_CONFIRMED_ERROR, () => (
  <AccountConfirmedErrorModal />
));
